export default __webpack_public_path__ + "static/media/higher_primary_logo_no_margin.d9651ef2.svg";